import { c as _c } from "react/compiler-runtime";
import { FormInput, Popover, Tooltip, copyTextToClipboard, toast, useTranslation as useUiTranslation } from '@systemeio/ui';
import { BLOGS_API, changePageTemplate, createPage, deletePage, duplicatePage, updatePage } from 'modules/blogs/api/blog-api';
import { useBlogPages } from 'modules/blogs/hooks/use-blog-pages';
import { BlogInterface } from 'modules/blogs/types/blog-interface';
import { BlogPagesEditInterface, BlogPagesInterface } from 'modules/blogs/types/blog-pages-interface';
import { getBlogPageUrl } from 'modules/blogs/utils/get-blog-page-url';
import React, { useState } from 'react';
import ConfirmationModal from 'shared/components/confirmation-modal';
import FormUrlPathInput from 'shared/components/form-url-path-input';
import ListingLayout from 'shared/components/listing-layout';
import { Table } from 'shared/components/table/table';
import { ColumnDefinitionInterface } from 'shared/components/table/types/column-interface';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { useUpdateData } from 'shared/hooks/use-update-data';
import useUser from 'shared/hooks/use-user';
import { usePagination } from 'shared/route-query/hooks/use-pagination';
import { dateTimeFormat } from 'shared/utils/date-time-format';
import { fetchWithErrors } from 'shared/utils/fetch-with-errors';
import { BlogEntityDuplicateInterface } from '../types/blog-entity-interface';
import BlogEntityDuplicateModal from './blog-entity-duplicate-modal';
import { CheckIcon, CopyIcon, QuestionMarkIcon } from '@systemeio/ui/icons';
import { getPageEditorUrl } from 'shared/utils/get-page-editor-url';
interface BlogPagesProps {
  blog?: BlogInterface;
  blogId: string;
}
const defaultValues: BlogPagesEditInterface = {
  name: '',
  path: ''
};
const defaultErrors: BlogPagesEditInterface = {
  name: '',
  path: ''
};
const BlogPages = t0 => {
  const $ = _c(169);
  const {
    blog,
    blogId
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    t: tUi
  } = useUiTranslation();
  const {
    user
  } = useUser();
  const {
    setPagination,
    pagination,
    setLimit,
    limit
  } = usePagination(true);
  let t1;
  if ($[0] !== blogId || $[1] !== limit || $[2] !== pagination) {
    t1 = {
      limit,
      pagination,
      id: blogId
    };
    $[0] = blogId;
    $[1] = limit;
    $[2] = pagination;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    blogPages,
    blogPagesMutate,
    blogPagesCounter
  } = useBlogPages(t1);
  const t2 = `${BLOGS_API}/${blogId}/pages`;
  let t3;
  if ($[4] !== setPagination || $[5] !== t2) {
    t3 = {
      api: t2,
      setPagination
    };
    $[4] = setPagination;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const updateData = useUpdateData(t3);
  const [errors, setErrors] = useState(defaultErrors);
  let t4;
  if ($[7] !== blog || $[8] !== blogPages || $[9] !== t || $[10] !== updateData) {
    t4 = async data => {
      ;
      try {
        await fetchWithErrors(async () => {
          if (blog) {
            await createPage(blog?.id, data);
            await updateData(true, blogPages);
          }
        }, setErrors);
        toast.success(t("dashboard.blog.pages.created"));
      } catch (t5) {
        const e = t5;
        throw e;
      }
    };
    $[7] = blog;
    $[8] = blogPages;
    $[9] = t;
    $[10] = updateData;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const onCreate = t4;
  let t5;
  if ($[12] !== blog || $[13] !== blogPages || $[14] !== blogPagesMutate || $[15] !== updateData) {
    t5 = async (page, data_0) => {
      const homePage = blogPages?.items.find(_temp);
      const postsPage = blogPages?.items.find(_temp2);
      const searchPage = blogPages?.items.find(_temp3);
      const isHomePage = page.id === homePage?.id;
      const isPostsPage = page.id === postsPage?.id;
      const isSearchPage = page.id === searchPage?.id;
      const updatedData = isHomePage || isPostsPage || isSearchPage ? {
        name: data_0.name
      } : data_0;
      ;
      try {
        await fetchWithErrors(async () => {
          if (blog) {
            const response = await updatePage(page.id, updatedData);
            await updateData(false, undefined, {
              mutationData: blogPages,
              onMutate: async () => {
                await blogPagesMutate(data_1 => {
                  if (data_1) {
                    return {
                      ...data_1,
                      items: data_1.items.map(el_2 => {
                        if (el_2.id === page.id) {
                          return {
                            ...response.data
                          };
                        } else {
                          return el_2;
                        }
                      })
                    };
                  }
                }, false);
              }
            });
          }
        }, setErrors);
      } catch (t6) {
        const e_0 = t6;
        throw e_0;
      }
    };
    $[12] = blog;
    $[13] = blogPages;
    $[14] = blogPagesMutate;
    $[15] = updateData;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  const onEdit = t5;
  let t6;
  if ($[17] !== blogPages || $[18] !== updateData) {
    t6 = async data_2 => {
      ;
      try {
        await deletePage(data_2.id);
        await updateData(false, blogPages);
      } catch (t7) {
        const e_1 = t7;
        throw e_1;
      }
    };
    $[17] = blogPages;
    $[18] = updateData;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  const onRemove = t6;
  let t7;
  if ($[20] !== blogPages || $[21] !== updateData) {
    t7 = async (id, data_3) => {
      await duplicatePage(id, data_3);
      await updateData(false, blogPages);
    };
    $[20] = blogPages;
    $[21] = updateData;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  const duplicateHandler = t7;
  let t8;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => setErrors(defaultErrors);
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  const onModalClose = t8;
  let t9;
  if ($[24] !== t) {
    t9 = t("global.title_caption");
    $[24] = t;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== t) {
    t10 = blogPage => <div className="flex w-full items-center gap-1.5 truncate"><a rel="noreferrer" className="primary-link w-fit truncate" href={getPageEditorUrl(blogPage.pageId)}>{blogPage.name}</a>{!blogPage.isEmptyLayout && <Tooltip mode="hover" label={t("dashboard.blog.pages.use_blog_layout")}><CheckIcon className="stroke-green" /></Tooltip>}</div>;
    $[26] = t;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] !== t10 || $[29] !== t9) {
    t11 = {
      key: "name",
      header: t9,
      widthPercent: 40,
      onRender: t10
    };
    $[28] = t10;
    $[29] = t9;
    $[30] = t11;
  } else {
    t11 = $[30];
  }
  let t12;
  if ($[31] !== t) {
    t12 = t("global.url");
    $[31] = t;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  let t13;
  let t14;
  if ($[33] !== blog || $[34] !== t || $[35] !== tUi) {
    t13 = blogPage_0 => {
      const url = getBlogPageUrl(blog, blogPage_0);
      return <div className="flex w-full gap-3"><Tooltip mode="hover" label={t("global.copy")} className="overflow-auto"><button onClick={async () => {
            await copyTextToClipboard(url, tUi);
          }} className="group w-full outline-hidden"><CopyIcon className="main-transition-colors group-focus-visible:fill-brand-primary hover:fill-brand-primary h-[16px] w-[16px] cursor-pointer sm:h-[20px] sm:w-[20px]" /></button></Tooltip><div className="truncate">{url}</div></div>;
    };
    t14 = blogPage_1 => {
      const url_0 = getBlogPageUrl(blog, blogPage_1);
      return <div className="flex w-full items-center gap-3"><span className="text-text-primary whitespace-nowrap font-bold">{t("global.url")}</span><div className="flex w-fit gap-3 truncate lg:w-full"><div className="truncate">{url_0}</div><Tooltip mode="hover" label={t("global.copy")}><button onClick={async () => {
              await copyTextToClipboard(url_0, tUi);
            }} className="group w-full outline-hidden"><CopyIcon className="group-focus-visible:fill-brand-primary hover:fill-brand-primary h-[16px] w-[16px] cursor-pointer sm:h-[20px] sm:w-[20px]" /></button></Tooltip></div></div>;
    };
    $[33] = blog;
    $[34] = t;
    $[35] = tUi;
    $[36] = t13;
    $[37] = t14;
  } else {
    t13 = $[36];
    t14 = $[37];
  }
  let t15;
  if ($[38] !== t12 || $[39] !== t13 || $[40] !== t14) {
    t15 = {
      key: "path",
      header: t12,
      widthPercent: 40,
      onRender: t13,
      onRenderSmall: t14
    };
    $[38] = t12;
    $[39] = t13;
    $[40] = t14;
    $[41] = t15;
  } else {
    t15 = $[41];
  }
  let t16;
  if ($[42] !== t) {
    t16 = t("global.created_on");
    $[42] = t;
    $[43] = t16;
  } else {
    t16 = $[43];
  }
  let t17;
  if ($[44] !== user?.dateFormat || $[45] !== user?.timeFormat || $[46] !== user?.timezone) {
    t17 = blogPage_2 => <span>{dateTimeFormat(blogPage_2.createdAt, {
        timeFormat: user?.timeFormat,
        dateFormat: user?.dateFormat,
        timeZone: user?.timezone
      })}</span>;
    $[44] = user?.dateFormat;
    $[45] = user?.timeFormat;
    $[46] = user?.timezone;
    $[47] = t17;
  } else {
    t17 = $[47];
  }
  let t18;
  if ($[48] !== t16 || $[49] !== t17) {
    t18 = {
      key: "createdAt",
      header: t16,
      widthPercent: 20,
      onRender: t17
    };
    $[48] = t16;
    $[49] = t17;
    $[50] = t18;
  } else {
    t18 = $[50];
  }
  let t19;
  if ($[51] !== t11 || $[52] !== t15 || $[53] !== t18) {
    t19 = [t11, t15, t18];
    $[51] = t11;
    $[52] = t15;
    $[53] = t18;
    $[54] = t19;
  } else {
    t19 = $[54];
  }
  const columns = t19;
  let t20;
  if ($[55] !== blogPages || $[56] !== blogPagesMutate || $[57] !== updateData) {
    t20 = async blogPage_3 => {
      await changePageTemplate(blogPage_3.id);
      await updateData(false, undefined, {
        mutationData: blogPages,
        onMutate: async () => {
          await blogPagesMutate(data_4 => {
            if (data_4) {
              return {
                items: data_4.items.map(item => {
                  if (item.id === blogPage_3.id) {
                    item = {
                      ...item,
                      isEmptyLayout: !item.isEmptyLayout
                    };
                  }
                  return item;
                }),
                hasMore: data_4.hasMore
              };
            }
          }, false);
        }
      });
    };
    $[55] = blogPages;
    $[56] = blogPagesMutate;
    $[57] = updateData;
    $[58] = t20;
  } else {
    t20 = $[58];
  }
  const changeBlogLayoutUsage = t20;
  let t21;
  if ($[59] !== t) {
    t21 = t("dashboard.blog.pages.title_plural");
    $[59] = t;
    $[60] = t21;
  } else {
    t21 = $[60];
  }
  let t22;
  if ($[61] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = ["path", "name"];
    $[61] = t22;
  } else {
    t22 = $[61];
  }
  let t23;
  if ($[62] !== t) {
    t23 = t("dashboard.blog.pages.create_blog_page");
    $[62] = t;
    $[63] = t23;
  } else {
    t23 = $[63];
  }
  let t24;
  if ($[64] !== t) {
    t24 = t("dashboard.blog.pages.create_new_blog_page");
    $[64] = t;
    $[65] = t24;
  } else {
    t24 = $[65];
  }
  let t25;
  if ($[66] !== errors || $[67] !== t) {
    t25 = {
      field: "name",
      onRender: (value, onChange) => <FormInput key="name-create" value={value} onChange={e_2 => onChange(e_2.target.value)} label={t("dashboard.blog.pages.blog_page_name")} error={errors.name} />
    };
    $[66] = errors;
    $[67] = t;
    $[68] = t25;
  } else {
    t25 = $[68];
  }
  let t26;
  if ($[69] !== blog?.domain || $[70] !== blog?.path || $[71] !== errors || $[72] !== t) {
    t26 = {
      field: "path",
      onRender: (value_0, onChange_0) => <FormUrlPathInput key="path-create" label={<div className="flex items-center gap-1">{t("global.url_path")}<Popover popoverClassName="max-w-[200px] sm:max-w-[350px]" label={t("dashboard.funnel.configuration.webinar.url_path_popover-2")}>{_temp4}</Popover></div>} domainName={blog?.domain.domainName} additionalPath={blog?.path} value={value_0} onChange={e_3 => onChange_0(e_3.target.value)} error={errors.path} />
    };
    $[69] = blog?.domain;
    $[70] = blog?.path;
    $[71] = errors;
    $[72] = t;
    $[73] = t26;
  } else {
    t26 = $[73];
  }
  let t27;
  if ($[74] !== t25 || $[75] !== t26) {
    t27 = [t25, t26];
    $[74] = t25;
    $[75] = t26;
    $[76] = t27;
  } else {
    t27 = $[76];
  }
  let t28;
  if ($[77] !== onCreate || $[78] !== t23 || $[79] !== t24 || $[80] !== t27) {
    t28 = {
      onCreate,
      onAfterLeave: onModalClose,
      requiredFields: t22,
      buttonCaption: t23,
      fullCaption: t24,
      needToast: false,
      defaultValues,
      creatable: t27
    };
    $[77] = onCreate;
    $[78] = t23;
    $[79] = t24;
    $[80] = t27;
    $[81] = t28;
  } else {
    t28 = $[81];
  }
  let t29;
  if ($[82] !== t) {
    t29 = t("dashboard.blog.pages.title");
    $[82] = t;
    $[83] = t29;
  } else {
    t29 = $[83];
  }
  let t30;
  if ($[84] !== blog) {
    t30 = {
      name: "view",
      openInNew: true,
      setHref: page_0 => getBlogPageUrl(blog, page_0)
    };
    $[84] = blog;
    $[85] = t30;
  } else {
    t30 = $[85];
  }
  let t31;
  if ($[86] !== t) {
    t31 = t("dashboard.actions.title.edit");
    $[86] = t;
    $[87] = t31;
  } else {
    t31 = $[87];
  }
  let t32;
  if ($[88] !== t31) {
    t32 = {
      caption: t31,
      name: "edit",
      openInNew: false,
      setHref: _temp5
    };
    $[88] = t31;
    $[89] = t32;
  } else {
    t32 = $[89];
  }
  let t33;
  if ($[90] !== t30 || $[91] !== t32) {
    t33 = [t30, t32];
    $[90] = t30;
    $[91] = t32;
    $[92] = t33;
  } else {
    t33 = $[92];
  }
  let t34;
  if ($[93] !== t) {
    t34 = t("dashboard.actions.title.duplicate");
    $[93] = t;
    $[94] = t34;
  } else {
    t34 = $[94];
  }
  let t35;
  if ($[95] !== duplicateHandler || $[96] !== t) {
    t35 = (opened, onClose, page_2, key) => <BlogEntityDuplicateModal key={key} opened={opened} blogEntity={page_2} title={t("dashboard.blog.page.duplicate_blog_page")} onClose={onClose} onUpdateData={async () => {
      onModalClose();
      onClose();
    }} duplicateHandler={duplicateHandler} />;
    $[95] = duplicateHandler;
    $[96] = t;
    $[97] = t35;
  } else {
    t35 = $[97];
  }
  let t36;
  if ($[98] !== t34 || $[99] !== t35) {
    t36 = {
      name: "duplicate",
      caption: t34,
      onActionRender: t35
    };
    $[98] = t34;
    $[99] = t35;
    $[100] = t36;
  } else {
    t36 = $[100];
  }
  let t37;
  if ($[101] !== t) {
    t37 = t("dashboard.blog.pages.use_blog_layout");
    $[101] = t;
    $[102] = t37;
  } else {
    t37 = $[102];
  }
  let t38;
  if ($[103] !== changeBlogLayoutUsage || $[104] !== t) {
    t38 = (opened_0, onClose_0, blogPage_5, key_0) => <ConfirmationModal toastCaption={t("dashboard.blog.pages.template_changed")} confirmationText={t("dashboard.blog.pages.use_blog_layout_description")} key={key_0} opened={opened_0} onClose={onClose_0} onConfirm={() => changeBlogLayoutUsage(blogPage_5)} />;
    $[103] = changeBlogLayoutUsage;
    $[104] = t;
    $[105] = t38;
  } else {
    t38 = $[105];
  }
  let t39;
  if ($[106] !== t37 || $[107] !== t38) {
    t39 = {
      name: "use-blog-layout",
      caption: t37,
      shouldRender: _temp6,
      onActionRender: t38
    };
    $[106] = t37;
    $[107] = t38;
    $[108] = t39;
  } else {
    t39 = $[108];
  }
  let t40;
  if ($[109] !== t) {
    t40 = t("dashboard.blog.pages.dont_use_blog_layout");
    $[109] = t;
    $[110] = t40;
  } else {
    t40 = $[110];
  }
  let t41;
  if ($[111] !== changeBlogLayoutUsage || $[112] !== t) {
    t41 = (opened_1, onClose_1, blogPage_7, key_1) => <ConfirmationModal confirmationText={t("dashboard.blog.pages.dont_use_blog_layout_description")} toastCaption={t("dashboard.blog.pages.template_changed")} key={key_1} opened={opened_1} onClose={onClose_1} onConfirm={() => changeBlogLayoutUsage(blogPage_7)} />;
    $[111] = changeBlogLayoutUsage;
    $[112] = t;
    $[113] = t41;
  } else {
    t41 = $[113];
  }
  let t42;
  if ($[114] !== t40 || $[115] !== t41) {
    t42 = {
      name: "dont-use-blog-layout",
      caption: t40,
      shouldRender: _temp7,
      onActionRender: t41
    };
    $[114] = t40;
    $[115] = t41;
    $[116] = t42;
  } else {
    t42 = $[116];
  }
  let t43;
  if ($[117] !== t36 || $[118] !== t39 || $[119] !== t42) {
    t43 = [t36, t39, t42];
    $[117] = t36;
    $[118] = t39;
    $[119] = t42;
    $[120] = t43;
  } else {
    t43 = $[120];
  }
  let t44;
  if ($[121] !== t) {
    t44 = t("dashboard.blog.pages.edit_pages");
    $[121] = t;
    $[122] = t44;
  } else {
    t44 = $[122];
  }
  let t45;
  if ($[123] !== errors || $[124] !== t) {
    t45 = {
      field: "name",
      onRender: (value_1, onChange_1) => <FormInput key="name-edit" value={value_1} onChange={e_4 => onChange_1(e_4.target.value)} label={t("dashboard.blog.pages.blog_page_name")} error={errors.name} />
    };
    $[123] = errors;
    $[124] = t;
    $[125] = t45;
  } else {
    t45 = $[125];
  }
  let t46;
  if ($[126] !== blogPages?.items) {
    t46 = (state, page_3) => {
      const homePage_0 = blogPages?.items.find(_temp8);
      const postsPage_0 = blogPages?.items.find(_temp9);
      const searchPage_0 = blogPages?.items.find(_temp10);
      return page_3.id !== homePage_0?.id && postsPage_0?.id !== page_3.id && searchPage_0?.id !== page_3.id;
    };
    $[126] = blogPages?.items;
    $[127] = t46;
  } else {
    t46 = $[127];
  }
  let t47;
  if ($[128] !== blog?.domain || $[129] !== blog?.path || $[130] !== errors || $[131] !== t) {
    t47 = (value_2, onChange_2) => <FormUrlPathInput key="path-edit" label={<div className="flex items-center gap-1">{t("global.url_path")}<Popover popoverClassName="max-w-[200px] sm:max-w-[350px]" label={t("dashboard.funnel.configuration.webinar.url_path_popover-2")}>{_temp11}</Popover></div>} domainName={blog?.domain.domainName} additionalPath={blog?.path} value={value_2} onChange={e_5 => onChange_2(e_5.target.value)} error={errors.path} />;
    $[128] = blog?.domain;
    $[129] = blog?.path;
    $[130] = errors;
    $[131] = t;
    $[132] = t47;
  } else {
    t47 = $[132];
  }
  let t48;
  if ($[133] !== t46 || $[134] !== t47) {
    t48 = {
      field: "path",
      shouldRender: t46,
      onRender: t47
    };
    $[133] = t46;
    $[134] = t47;
    $[135] = t48;
  } else {
    t48 = $[135];
  }
  let t49;
  if ($[136] !== t45 || $[137] !== t48) {
    t49 = [t45, t48];
    $[136] = t45;
    $[137] = t48;
    $[138] = t49;
  } else {
    t49 = $[138];
  }
  let t50;
  if ($[139] !== onEdit || $[140] !== t44 || $[141] !== t49) {
    t50 = {
      onEdit,
      onModalClose,
      fullCaption: t44,
      editable: t49
    };
    $[139] = onEdit;
    $[140] = t44;
    $[141] = t49;
    $[142] = t50;
  } else {
    t50 = $[142];
  }
  let t51;
  if ($[143] !== onRemove) {
    t51 = {
      shouldRender: _temp12,
      onChange: onRemove
    };
    $[143] = onRemove;
    $[144] = t51;
  } else {
    t51 = $[144];
  }
  let t52;
  if ($[145] !== t33 || $[146] !== t43 || $[147] !== t50 || $[148] !== t51) {
    t52 = {
      openLink: t33,
      custom: t43,
      settings: t50,
      remove: t51
    };
    $[145] = t33;
    $[146] = t43;
    $[147] = t50;
    $[148] = t51;
    $[149] = t52;
  } else {
    t52 = $[149];
  }
  let t53;
  if ($[150] !== pagination || $[151] !== setPagination) {
    t53 = {
      pagination,
      setPagination
    };
    $[150] = pagination;
    $[151] = setPagination;
    $[152] = t53;
  } else {
    t53 = $[152];
  }
  let t54;
  if ($[153] !== limit || $[154] !== setLimit) {
    t54 = {
      limit,
      setLimit
    };
    $[153] = limit;
    $[154] = setLimit;
    $[155] = t54;
  } else {
    t54 = $[155];
  }
  let t55;
  if ($[156] !== blogPages || $[157] !== columns || $[158] !== t29 || $[159] !== t52 || $[160] !== t53 || $[161] !== t54) {
    t55 = <Table caption={t29} actions={t52} data={blogPages} columns={columns} paginator={t53} limiter={t54} />;
    $[156] = blogPages;
    $[157] = columns;
    $[158] = t29;
    $[159] = t52;
    $[160] = t53;
    $[161] = t54;
    $[162] = t55;
  } else {
    t55 = $[162];
  }
  let t56;
  if ($[163] !== blogPages || $[164] !== blogPagesCounter || $[165] !== t21 || $[166] !== t28 || $[167] !== t55) {
    t56 = <ListingLayout title={t21} counter={blogPagesCounter} data={blogPages} type="compact" createData={t28}>{t55}</ListingLayout>;
    $[163] = blogPages;
    $[164] = blogPagesCounter;
    $[165] = t21;
    $[166] = t28;
    $[167] = t55;
    $[168] = t56;
  } else {
    t56 = $[168];
  }
  return t56;
};
export default BlogPages;
function _temp(el) {
  return el.path === "";
}
function _temp2(el_0) {
  return el_0.path === "posts";
}
function _temp3(el_1) {
  return el_1.path === "search";
}
function _temp4(show) {
  return <QuestionMarkIcon className={`${show ? "fill-brand-primary" : "fill-fill-primary"} group-focus-visible:fill-brand-primary h-[16px] w-[16px]`} />;
}
function _temp5(page_1) {
  return getPageEditorUrl(page_1.pageId);
}
function _temp6(blogPage_4) {
  return blogPage_4.isEmptyLayout;
}
function _temp7(blogPage_6) {
  return !blogPage_6.isEmptyLayout;
}
function _temp8(el_3) {
  return el_3.path === "";
}
function _temp9(el_4) {
  return el_4.path === "posts";
}
function _temp10(el_5) {
  return el_5.path === "search";
}
function _temp11(show_0) {
  return <QuestionMarkIcon className={`${show_0 ? "fill-brand-primary" : "fill-fill-primary"} group-focus-visible:fill-brand-primary h-[16px] w-[16px]`} />;
}
function _temp12(page_4) {
  return page_4.path !== "" && page_4.path !== "posts" && page_4.path !== "search";
}